import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c09cdb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "inquiryConfirmModal",
  tabindex: "-1",
  "aria-labelledby": "inquiryConfirmModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "modal-body px-lg-3 px-2 fs-75" }
const _hoisted_6 = { class: "mb-4 mb-lg-5 fs-75" }
const _hoisted_7 = { class: "d-flex mx-0 px-0" }
const _hoisted_8 = { class: "fs-bold fs-75" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex mx-0 px-0"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-bold fs-75" }, "※", -1))
const _hoisted_11 = { class: "mx-0 px-0 fs-bold fs-75" }
const _hoisted_12 = { class: "row mb-3 border-bottom" }
const _hoisted_13 = { class: "col-md-3 fs-7" }
const _hoisted_14 = { class: "pt-2 pt-xl-0 col-md-9 fs-7" }
const _hoisted_15 = { class: "row mb-3 border-bottom" }
const _hoisted_16 = { class: "col-md-3 fs-7" }
const _hoisted_17 = { class: "pb-2 pt-2 pt-xl-0 break-spaces text-break col-xl-9" }
const _hoisted_18 = { class: "border-bottom mb-3" }
const _hoisted_19 = { class: "d-flex mx-0 px-0" }
const _hoisted_20 = { class: "d-flex mx-0 px-0" }
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "col-xl-3 fs-7" }
const _hoisted_23 = { class: "col-xl-9 text-break fs-7" }
const _hoisted_24 = {
  key: 1,
  class: "row"
}
const _hoisted_25 = { class: "col-xl-3 fs-7" }
const _hoisted_26 = { class: "col-xl-9 text-break fs-7" }
const _hoisted_27 = {
  key: 2,
  class: "row pb-3"
}
const _hoisted_28 = { class: "col-xl-3 fs-7" }
const _hoisted_29 = { class: "col-xl-9 text-break fs-7" }
const _hoisted_30 = { class: "row pb-3 border-bottom mb-3" }
const _hoisted_31 = { class: "col-xl-3 fs-7" }
const _hoisted_32 = { class: "col-xl-8 text-break fs-7" }
const _hoisted_33 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse mt-3" }
const _hoisted_34 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_35 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_36 = {
  class: "modal fade",
  id: "inquiryCompleted",
  tabindex: "-1",
  "aria-labelledby": "inquiryCompleted",
  "aria-hidden": "true"
}
const _hoisted_37 = { class: "modal-dialog modal-lg" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_40 = { class: "modal-body border-bottom pb-4 mb-4 px-4" }
const _hoisted_41 = { class: "fw-bold text-center fs-6 mb-4 mb-lg-5" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = { class: "d-flex justify-content-center mb-4" }

import { computed, ref, watchEffect, PropType, onMounted, ComputedRef } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

import { translate } from '@/languages/i18n'
import { COMMUNITY_STORE, INQUIRY_STORE, ROOT_STORE } from '@/store/constants'
import Button from '@/components/button/index.vue'
import { buildFormData } from '@/utils'
import inquiryServices from '@/services/inquiry.services'

import { Modal } from 'bootstrap'
import { CommunityStateTypes } from '@/store/modules/community'


export default /*#__PURE__*/_defineComponent({
  props: {
  handleServerError: Function as PropType<() => void | undefined>,
},
  setup(__props) {

const props = __props

const modalCompleted = ref()
const modalConfirm = ref()
const modalForm = ref()

const router = useRouter()
const route = useRoute()
const store = useStore()

const inquiryData = computed(() => store.getters[INQUIRY_STORE.GETTERS.INQUIRY_DATA])
const inquiryCategories = computed(() => store.getters[INQUIRY_STORE.GETTERS.INQUIRY_CATEGORIES])
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const getMe = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])


const checkBoxes = ref([])
const isSubmitting = ref<boolean>(false)

watchEffect(() => {
  checkBoxes.value = Object.entries(inquiryCategories.value).map((item: any) => {
    return { id: item[0], title: item[1] }
  })
})

const onSubmit = async (): void => {
  const formSubmit = new FormData()
  isSubmitting.value = true
  buildFormData(formSubmit, inquiryData.value)

  try {
    const response = await inquiryServices.postInquiryApi(formSubmit)

    if (response.status === 200) {
      props.handleServerError(false)
      modalCompleted.value?.show()
      modalConfirm.value?.hide()
      store.dispatch(INQUIRY_STORE.ACTIONS.SET_INQUIRY_DATA, { inquiry_type: '', content: '', file1: '', file2: '', file3: '', email: '' })
    } else {
      props.handleServerError(true)
      modalForm.value?.show()
      modalConfirm.value?.hide()
    }
    isSubmitting.value = false
  } catch (error) {
    props.handleServerError(true)
    isSubmitting.value = false

    console.log('err', error.response)
  }
}
const handleTransitDirect = () => {
  modalConfirm.value?.hide()

  router.push(`/${route.path.split('/')[1]}/communities/${route.params?.id}/direct_chat/${getMe.value?.direct_id}`)
}

onMounted(() => {
  modalCompleted.value = new Modal(document.getElementById('inquiryCompleted'))
  modalConfirm.value = new Modal(document.getElementById('inquiryConfirmModal'))
  modalForm.value = new Modal(document.getElementById('inquiryFormModal'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              class: "bg-white p-0 p-lg-4 pt-0 pt-lg-0"
            }, [
              _createElementVNode("h1", {
                class: _normalizeClass(['fw-bold text-center mb-4 mb-lg-5', _unref(isMobile) ? 'fs-6' : 'fs-5'])
              }, _toDisplayString(_unref(translate)('inquiry')), 3),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('ST50noteInquiry')), 1)
                ]),
                (_unref(route).params.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(_unref(translate)('ST50forInquiryAboutCommunity')), 1),
                        _createElementVNode("span", {
                          class: "link text-decoration-underline cursor-pointer",
                          "data-bs-dismiss": "modal",
                          onClick: handleTransitDirect
                        }, _toDisplayString(_unref(translate)('ST50here')), 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(translate)('ST50thanks')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(translate)('inquiryType')), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(checkBoxes.value.find((item) => item.id === _unref(inquiryData).inquiry_type)?.title), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(translate)('inquiryContent')), 1),
                _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(inquiryData).content), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h3", {
                  class: _normalizeClass(['fw-bold pt-4', _unref(isMobile) ? 'fs-75' : 'fs-7'])
                }, _toDisplayString(_unref(translate)('noteError')), 3),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h3", {
                    class: _normalizeClass(['fw-bold', _unref(isMobile) ? 'fs-75' : 'fs-7'])
                  }, "※", 2),
                  _createElementVNode("h3", {
                    class: _normalizeClass(['fw-bold', _unref(isMobile) ? 'fs-75' : 'fs-7'])
                  }, _toDisplayString(_unref(translate)('ST50noteError1')), 3)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h3", {
                    class: _normalizeClass(['fw-bold', _unref(isMobile) ? 'fs-75' : 'fs-7'])
                  }, "※", 2),
                  _createElementVNode("h3", {
                    class: _normalizeClass(['fw-bold', _unref(isMobile) ? 'fs-75' : 'fs-7'])
                  }, _toDisplayString(_unref(translate)('ST50noteError2')), 3)
                ]),
                (_unref(inquiryData).file1.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(translate)('attachment')) + "(1)", 1),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(inquiryData).file1.name), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(inquiryData).file2.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(translate)('attachment')) + "(2)", 1),
                      _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(inquiryData).file2.name), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(inquiryData).file3.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(translate)('attachment')) + "(3)", 1),
                      _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(inquiryData).file3.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(translate)('emailReply')), 1),
                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(inquiryData).email), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(Button, {
                    title: _unref(translate)('titleButtonEdit'),
                    type: 'secondary',
                    dataBsToggle: 'modal',
                    dataBsTarget: '#inquiryFormModal'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(Button, {
                    title: '送信する',
                    onClick: onSubmit,
                    type: 'secondary',
                    loading: isSubmitting.value,
                    disabled: isSubmitting.value
                  }, null, 8, ["loading", "disabled"])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h3", _hoisted_41, _toDisplayString(_unref(translate)('inquiry')), 1),
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_unref(translate)('thanksForContact')), 1),
              _hoisted_42,
              _createTextVNode(_toDisplayString(_unref(translate)('afterContact')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})